<template>
  <Article
    v-if="apaPostBy"
    :post="apaPostBy"
    :is-free="apaPostBy.free"
    role="main"
  />
</template>

<script>
import {
  enhance,
  generateOpenGraphMeta,
  generateLdPlusJson,
} from '~plugins/utils'
import { entityDecode } from '~~/utils/entity-decode.js'
import Article from '~components/content/detail-view/Article.vue'

export default {
  components: {
    Article,
  },

  async asyncData({ error, app, params }) {
    try {
      const apaPostBy = await app.apolloProvider.defaultClient
        .query({
          query: require('~base/graphql/queries/ApaPostById.gql'),
          variables: { apaPostId: parseInt(params.id) },
        })
        .then(({ data }) => {
          if (data.apaPostBy) {
            if (
              data.apaPostBy.thumbnail &&
              data.apaPostBy.thumbnail.src &&
              data.apaPostBy.blocks[0].ot !== 'core/image'
            ) {
              data.apaPostBy.blocks = [
                {
                  a: [],
                  t: 'HtmlBlock',
                  ot: 'core/image',
                  h: `<figure class="wp-block-image"><img src="${data.apaPostBy.thumbnail.src}" /><figcaption></figcaption></figure>`,
                },
                ...data.apaPostBy.blocks,
              ]
            }
            return enhance(data.apaPostBy, app.$config)
          }
        })
      if (!apaPostBy) error({ statusCode: 404 })
      return { apaPostBy }
    } catch (Error) {
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      apaPostBy: undefined,
      sentToPiano: false,
    }
  },
  head() {
    return {
      title: this.apaPostBy
        ? `${entityDecode(this.apaPostBy.title)} - ${this.$config.siteName}`
        : '...',
      meta: this.apaPostBy ? this.meta : [],
      __dangerouslyDisableSanitizers: ['script'],
      script: generateLdPlusJson(this.apaPostBy),
    }
  },
  computed: {
    meta() {
      return generateOpenGraphMeta(this.$config, this.apaPostBy)
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$store.dispatch('ads/pageChanged', { pageType: 'article' })
    if (!this.sentToPiano) {
      this.$store.dispatch('paywall/executeExperience', this.apaPostBy)
      this.sentToPiano = true
    }
  },
}
</script>
